import { defineComponent as _defineComponent } from 'vue'
import { LOGOUT_USER } from "@/store/ActionTypes";
import UserDetails from "@/models/User/UserDetails";
import {useStore} from "@/hooks/useStore";
import { UserTypes } from "@/models/User/UserTypes";
import {SubscriptionStatus} from "@/models/Subscriptions/SubscriptionStatus";
import {computed} from "vue";
import HeaderNotifications from "@/components/HeaderNotifications.vue";

type vHeaderProps = {
  menuShow: boolean;
  userDetails: UserDetails;
  bannerText?: string;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'vHeader',
  props: {
    menuShow: { type: Boolean },
    userDetails: null,
    bannerText: { default: '' }
  },
  emits: ['toggleHeaderMenu', 'toggleNavigation'],
  setup(__props: any, { emit }) {

const props = __props as { menuShow: boolean, userDetails: UserDetails, bannerText: string };




const store = useStore();

const shouldShowPaymentOption = computed(() => {
  return (
    props.userDetails.userType === UserTypes.Owner
    && (!props.userDetails.isSpecial || props.userDetails.subscriptionStatus == SubscriptionStatus.Expired)
  );
});

const showNotifications = computed(() => {
  return ![
    UserTypes.Administrator,
    UserTypes.SuperAdministrator,
    UserTypes.Helpdesk,
  ].includes(props.userDetails.userType);
});

const notificationUserKey = computed(() => {
  return String(props.userDetails.userId || props.userDetails.email || "anonymous");
});

function toggleMenu() {
  emit("toggleHeaderMenu");
}

function logout() {
  store.value.dispatch(LOGOUT_USER);
}

return { __sfc: true,props, emit, store, shouldShowPaymentOption, showNotifications, notificationUserKey, toggleMenu, logout, UserTypes, HeaderNotifications }
}

})